// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import { Button, modal, H } from "@lifepay/rc-ui-toolkit";
import { format } from "date-fns";
// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import actions from "model/actions";
import selectors from "model/selectors";

// import PersonSearchResults from "components/client-search/PersonSearchResults";
// import CompanySearchResults from "components/client-search/CompanySearchResults";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./IncomingCall.m.scss";

// const ClientSearchData = queryFactory(searchClients);
// const BlockCardMutation = mutationFactory(blockCard);

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      calls: selectors.clients.calls$$(state),
      currentCall: selectors.clients.currentCall$$(state),
      mostRecentCall: selectors.clients.mostRecentCall$$(state),
      showCallInfo: selectors.clients.showCallInfo$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    acceptIncomingCall: actions.clients.acceptIncomingCall,
    muteIncomingCall: actions.clients.muteIncomingCall,
    clientSearchPageEnter: actions.app.clientSearchPageEnter,
    clientSearchPageLeave: actions.app.clientSearchPageLeave,
  }
)
@themr("incomingCall", styles)
export default class IncomingCall extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    basePath: PropTypes.string,
    calls: PropTypes.object,
    currentCall: PropTypes.object,
    mostRecentCall: PropTypes.object,
    showCallInfo: PropTypes.bool,
    // action creators:
    acceptIncomingCall: PropTypes.func,
    muteIncomingCall: PropTypes.func,
    clientSearchPageEnter: PropTypes.func,
    clientSearchPageLeave: PropTypes.func,
  };

  acceptIncomingCall = ({ callId, clientId }) => {
    const { acceptIncomingCall, history } = this.props;
    acceptIncomingCall({
      callId,
      clientId,
    });
    history.push(`/client/p-${clientId}/menu`);
  };

  acceptIncomingCallWrongClient = ({ callId }) => {
    const { acceptIncomingCall, history } = this.props;
    acceptIncomingCall({
      callId,
      clientNotFound: true,
    });
    history.push(`/client/search`);
  };

  muteIncomingCall = ({ callId }) => {
    const { muteIncomingCall } = this.props;
    muteIncomingCall({ callId });
  };

  render() {
    const {
      theme,
      // calls,
      currentCall,
      mostRecentCall,
      showCallInfo,
    } = this.props;

    const callToShow = currentCall || mostRecentCall;

    const loading = callToShow && callToShow.auxInfoLoading;
    const possibleClients = callToShow && callToShow.possibleClients;
    const noClient = possibleClients && possibleClients.size < 1;
    const phone = callToShow && callToShow.clientPhone;
    const callId = callToShow && callToShow.id;
    const client =
      possibleClients && possibleClients.size === 1
        ? possibleClients.first()
        : null;
    const clients =
      possibleClients && possibleClients.size > 1 ? possibleClients : null;

    // const showCallInfo = currentCall && !currentCall.clientNotFound;

    return (
      <modal.ModalBox isOpen={showCallInfo}>
        {showCallInfo && (
          <div className={classnames(theme.modal)}>
            <div className={classnames(theme.header)}>
              <H t="h3">{`Входящий звонок`}</H>
              <H t="h5">{`тел. ${phone}`}</H>
            </div>
            {loading ? (
              <div className={classnames(theme.body)}>{"loading"}</div>
            ) : (
              <div className={classnames(theme.body)}>
                {noClient ? (
                  <div className={classnames(theme["lone-client"])}>
                    <div className={classnames(theme.client)}>
                      {"Клиент не определен"}
                    </div>
                  </div>
                ) : null}
                {client ? (
                  <div className={classnames(theme["lone-client"])}>
                    <div className={classnames(theme.client)}>
                      {client.data.clientName}
                    </div>
                  </div>
                ) : null}
                {clients ? (
                  <div className={classnames(theme.clients)}>
                    <div className={classnames(theme.header)}>
                      <H t="h4">{"Возможные совпадения для номера"}</H>
                    </div>
                    {clients.map((item) => (
                      <div key={item.id} className={classnames(theme.client)}>
                        <div className={classnames(theme.id)}>{`id: ${
                          item.id
                        }`}</div>
                        <div className={classnames(theme.name)}>
                          {item.data.clientName}
                        </div>
                        <div className={classnames(theme.date)}>
                          {format(item.data.birthDate, "MM.DD.YYYY")}
                        </div>
                        <div className={classnames(theme.controls)}>
                          <Button
                            type={"main"}
                            size={"small"}
                            onClick={() => {
                              this.acceptIncomingCall({
                                callId,
                                clientId: item.id,
                                type: item.type,
                              });
                            }}
                          >
                            {"Работать с клиентом"}
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
                <div className={classnames(theme.controls)}>
                  {client && (
                    <Button
                      type={"main"}
                      size={"medium"}
                      onClick={() => {
                        this.acceptIncomingCall({
                          callId,
                          clientId: client.id,
                          type: client.type,
                        });
                      }}
                    >
                      {"Работать с клиентом"}
                    </Button>
                  )}
                </div>
                <div className={classnames(theme["main-controls"])}>
                  {noClient ? (
                    <Button
                      type={"alt"}
                      size={"medium"}
                      onClick={() => {
                        this.acceptIncomingCallWrongClient({
                          callId,
                        });
                      }}
                    >
                      {"Искать клиента"}
                    </Button>
                  ) : (
                    <Button
                      type={"alt"}
                      size={"small"}
                      onClick={() => {
                        this.acceptIncomingCallWrongClient({
                          callId,
                        });
                      }}
                    >
                      {"Другой клиент"}
                    </Button>
                  )}
                  {!currentCall && mostRecentCall ? (
                    <H t="h5">{`Звонок сброшен`}</H>
                  ) : null}
                  {!currentCall &&
                    mostRecentCall && (
                      <Button
                        type={"negative"}
                        size={"small"}
                        onClick={() => {
                          this.muteIncomingCall({
                            callId,
                          });
                        }}
                      >
                        {"Закрыть"}
                      </Button>
                    )}
                </div>
              </div>
            )}
          </div>
        )}
        {/* <div className={classnames(theme.inner)}>
            <ClientSearchData
              skip={clientType === "PERSON" ? personSkip : companySkip}
              searchType={clientType}
              searchBy={personSearchType}
              search={currentSearch}
            >
              {({ data, mutate }) => {
                switch (clientType) {
                  case "PERSON":
                    return (
                      <PersonSearchResults
                        data={data}
                        workWithClient={this.workWithClient}
                      />
                    );
                  case "COMPANY":
                    return (
                      <CompanySearchResults
                        data={data}
                        workWithClient={this.workWithClient}
                      />
                    );
                  default:
                    return null;
                }
              }}
            </ClientSearchData>
          </div> */}
      </modal.ModalBox>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/IncomingCall/IncomingCall.js